import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { borderRadius3, space2 } = theme();
    return StyleSheet.create({
        aspectRatioView: {
            width: "100%",
        },
        image: {
            borderRadius: borderRadius3,
            height: "100%",
            width: "100%",
        },
        pressable: {
            borderRadius: borderRadius3,
            height: "100%",
            width: "100%",
        },
        text: {
            marginTop: space2,
        },
    });
};
export { style };
